"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const queHacemos = [{
  titulo: "Sesiones de discovery con stakeholders clave",
  detalle: "Conversaciones con la gente que vive la operación todos los días — no solo con quien firma el contrato. La diferencia entre cómo se cree que funciona el proceso y cómo funciona en realidad suele ser donde está el fulcro."
}, {
  titulo: "Mapeo de procesos críticos y stack tecnológico",
  detalle: "Inventario real de qué herramientas existen, cómo se conectan, dónde la información cambia de sistema y dónde se pierde."
}, {
  titulo: "Identificación de cuellos de botella y oportunidades",
  detalle: "No los más visibles — los que tienen mayor efecto palanca. A veces no es el proceso del que el equipo se queja más; es el que aparece tres pasos antes y nadie estaba mirando."
}, {
  titulo: "Diseño de arquitectura recomendada",
  detalle: "Cómo deberían estar conectadas las herramientas, qué automatizar, qué dejar manual, qué herramienta agregar y qué herramienta retirar."
}, {
  titulo: "Roadmap priorizado por valor de negocio",
  detalle: "Qué hacer primero, qué después, qué en seis meses. Priorizado por impacto, no por orden de queja."
}];
export default function QueHacemosDiagnostico() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="diagnostico-que-hacemos" id="que-hacemos" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-12">
            Qué hacemos.
          </h2>

          <div className="space-y-12">
            {queHacemos.map((item, i) => <ItemHacemos key={i} titulo={item.titulo} detalle={item.detalle} index={i} />)}
          </div>
        </div>
      </div>
    </section>;
}
function ItemHacemos({
  titulo,
  detalle,
  index
}: {
  titulo: string;
  detalle: string;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <h3 className="font-serif text-2xl md:text-3xl text-foreground font-normal leading-tight mb-3">
        {titulo}
      </h3>
      <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed max-w-3xl">
        {detalle}
      </p>
    </div>;
}